import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowLeftOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m7 14 .99-.99L3.68 8.7H15V7.3H3.68l4.31-4.31L7 2 1 8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowLeftOutlinedSize16Glyph.displayName = 'ArrowLeftOutlinedSize16Glyph';
